<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow p-3 mb-3">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    {{ $t("w-points-generated") }}
                  </h3>
                </div>
                <div class="col text-right">
                  <b-button
                    @click="viewStyle = false"
                    v-b-tooltip.hover
                    :title="$t('graphic')"
                    variant="success"
                    size="sm"
                    ><i class="ri-bar-chart-line"></i
                  ></b-button>
                  <b-button
                    v-b-tooltip.hover
                    @click="viewStyle = true"
                    :title="$t('list')"
                    variant="danger"
                    size="sm"
                    ><i class="ri-list-check-2"></i
                  ></b-button>
                </div>
              </div>
            </div>
            <div class="p-1" v-if="!viewStyle">
              <ChartPoint />
            </div>
            <div class="p-1" v-if="viewStyle">
              <TablePoint />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import ChartPoint from "./Dashboard/ChartPointGenerate.vue";
import TablePoint from "./Dashboard/TablePointsGenerates.vue";
export default {
  components: {
    ChartPoint,
    TablePoint,
  },
  async mounted() {
    await this.fetchPointsGenerated();
  },
  data() {
    return {
      viewStyle: false,
    };
  },
  methods: {
    ...mapActions({
      fetchPointsGenerated: "home/fetchPointsGenerated",
    }),
  },
};
</script>